import { css } from '@emotion/core';
import { unset } from 'lodash';
import { colorsPalette } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../../utils/constants';

export const inActiveArrow = css({
  color: colorsPalette.grey40,
});
export const homepageSlide = css({
  [MediaQueries.md]: {
    width: '100%',
  },

  '.morestories': {
    borderBottom: '1px solid #d7d7d7',
    display: ['-webkit-box', '-webkit-flex', '-ms-flexbox', 'flex'],
    WebkitBoxPack: 'justify',
    marginRight: '80px',
    WebkitJustifyContent: 'space-between',
    msFlexPack: 'justify',
    justifyContent: 'space-between',
    [MediaQueries.xl]: {
      marginRight: '45px',
    },

    [MediaQueries.md]: {
      marginRight: '0px',
    },
    [MediaQueries.sm]: {
      marginRight: '0px',
      display: 'flex',
      alignItems: 'center',
    },

    h2: {
      fontSize: '18px',
      fontWeight: 400,
      lineHeight: 1.78,
      display: 'inline-block',
      paddingBottom: '24px',
    },

    '.arrow_sec': {
      display: 'flex',
    },
  },

  '.swiper-container': {
    width: 'calc(100% + 75px)',
    paddingLeft: '0px',
    marginLeft: '0px',
    [MediaQueries.xl]: {
      width: '832px',
    },
  },

  '.swiper-pagination': {
    display: 'flex',
    justifyContent: 'center',
    '.swiper-pagination-bullet-active': {
      background: '#E52500',
    },
  },

  [MediaQueries.sm]: {
    width: '100%',
  },

  width: 'calc(100% + 78px)',
  position: 'relative',

  // '.shadowslide': {
  //   height: '429px',
  //   zIndex: '9',
  //   right: '0',
  //   width: '270px',
  //   display: 'none',
  //   position: 'absolute',
  //   background:
  //     'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)',
  // },

  '.swiper-wrapper': {
    boxSizing: 'inherit',
    transitionTimingFunction: 'linear',
  },

  // '.regus-button-prev': {
  //   display: 'none',
  // },
  // '.regus-button-next': {
  //   display: 'none',
  // },

  '&:hover': {
    '.regus-button-prev': {
      display: 'flex',
    },
    '.regus-button-next': {
      display: 'flex',
    },
  },
  // '.swiper-slide:first-child': {
  //   marginRight: '0px',
  // },
  '.swiper-slide': {
    width: 295,
    maxWidth: 295,
    // padding: '32px 0px',
    [MediaQueries.lg]: {
      width: 295,
    },
    [MediaQueries.md]: {
      width: 295,
    },
    [MediaQueries.sm]: {
      width: 295,
      // padding: '40px 0px 0px',
      // marginRight: '16px !important',
    },
  },

  '.regus-button-prev': {
    position: 'relative',
    zIndex: 1,
    cursor: 'pointer',
    display: 'flex',
    border: '0',
    outline: '0px',
    justifyContent: 'center',
    width: '48px',
    height: '48px',
    backgroundColor: '#fff',
  },

  '.regus-button-next': {
    position: 'relative',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'flex-end',
    zIndex: 1,
    width: '48px',
    height: '48px',
    outline: '0px',
    border: '0',
    backgroundColor: '#fff',

    [MediaQueries.sm]: {
      width: '28px',
    },
  },
});
